import { render, staticRenderFns } from "./testScore.vue?vue&type=template&id=a62965ee&scoped=true&"
import script from "./testScore.vue?vue&type=script&lang=js&"
export * from "./testScore.vue?vue&type=script&lang=js&"
import style0 from "./testScore.vue?vue&type=style&index=0&id=a62965ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62965ee",
  null
  
)

export default component.exports